import {
  MessageBar,
  MessageBarActions,
  MessageBarBody,
  MessageBarProps,
  MessageBarTitle,
  makeStyles,
  tokens,
} from "@fluentui/react-components";
import React from "react";

const useStyles = makeStyles({
  // ヘッダー直下に全幅で垂れ下がる帯として使うため左右の枠線を消す
  band: {
    borderLeftStyle: "none",
    borderRightStyle: "none",
  },
  body: {
    fontSize: tokens.fontSizeBase200,
    whiteSpace: "normal",
  },
  title: {
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightMedium,
  },
  // デザインの操作欄と同じ余白を取る
  actions: {
    paddingTop: "6px",
    paddingBottom: "6px",
    columnGap: tokens.spacingHorizontalS,
  },
});

export const AppMessageBar: React.FC<{
  intent: MessageBarProps["intent"];
  title?: React.ReactNode;
  children?: React.ReactNode;
  actions?: React.ReactNode;
}> = ({ intent, title, children, actions }) => {
  const styles = useStyles();
  return (
    // layout="auto" は幅に 0.5px 以上の端数があると広い幅でも 2 段組になるため、1 段に固定して本文を折り返す
    <MessageBar
      intent={intent}
      layout="singleline"
      shape="square"
      className={styles.band}
    >
      <MessageBarBody className={styles.body}>
        {title && (
          <MessageBarTitle className={styles.title}>{title}</MessageBarTitle>
        )}
        {children}
      </MessageBarBody>
      {actions && (
        <MessageBarActions className={styles.actions}>
          {actions}
        </MessageBarActions>
      )}
    </MessageBar>
  );
};
